import SettingSelect from "./SettingSelect";
import ToggleSetting from "./ToggleSetting";
import SettingInput from "./SettingInput";
import SettingSlider from "./SettingSlider";


export default function SettingsPanel({ settings, updateSettings, updateReasoning, resetSettings, responseMode, setResponseMode }) {
    return (
        <div className="space-y-4 text-sm">
            <h2 className="font-semibold text-lg text-[#4267B2]">⚙️ การตั้งค่าโมเดล</h2>

            <SettingSlider label="Temperature" tooltip="ควบคุมความสุ่มของคำตอบ" value={settings.temperature} min={0} max={2} step={0.1} onChange={(v) => updateSettings('temperature', v)} />
            <SettingSlider label="Top P" tooltip="จำกัดความหลากหลาย" value={settings.topP} min={0} max={1} step={0.01} onChange={(v) => updateSettings('topP', v)} />
            <SettingSlider label="Top K" tooltip="เลือก K token ที่ดีที่สุด" value={settings.topK} min={0} max={100} step={1} onChange={(v) => updateSettings('topK', v)} />
            <SettingSlider label="Frequency Penalty" tooltip="ลดคำซ้ำ" value={settings.frequencyPenalty} min={-2} max={2} step={0.1} onChange={(v) => updateSettings('frequencyPenalty', v)} />
            <SettingSlider label="Presence Penalty" tooltip="เพิ่มหัวข้อใหม่" value={settings.presencePenalty} min={-2} max={2} step={0.1} onChange={(v) => updateSettings('presencePenalty', v)} />
            <SettingSlider label="Repetition Penalty" tooltip="ลงโทษคำซ้ำ" value={settings.repetitionPenalty} min={0} max={2} step={0.1} onChange={(v) => updateSettings('repetitionPenalty', v)} />
            <SettingSlider label="Min P" tooltip="จำกัดความน่าจะเป็นต่ำสุด" value={settings.minP} min={0} max={1} step={0.01} onChange={(v) => updateSettings('minP', v)} />
            <SettingSlider label="Top A" tooltip="ค่าสุ่มแบบ advanced" value={settings.topA} min={0} max={1} step={0.01} onChange={(v) => updateSettings('topA', v)} />

            <SettingInput label="Seed" tooltip="กำหนด Seed คำตอบซ้ำได้" type="number" placeholder="ไม่บังคับ" value={settings.seed ?? ''} onChange={(v) => updateSettings('seed', v)} />
            <SettingInput label="Max Tokens" tooltip="จำกัด token" type="number" placeholder="ไม่บังคับ" value={settings.maxTokens ?? ''} onChange={(v) => updateSettings('maxTokens', v)} />
            <ToggleSetting label="Logprobs" tooltip="เปิดดูโอกาส token" value={settings.logprobs} onChange={(v) => updateSettings('logprobs', v)} />
            <SettingInput label="Top Logprobs" tooltip="จำนวน token ที่โชว์" type="number" placeholder="0-20" value={settings.topLogprobs ?? ''} onChange={(v) => updateSettings('topLogprobs', v)} />

            <ToggleSetting label="Streaming" tooltip="แสดงคำตอบแบบสตรีม" value={settings.streaming} onChange={(v) => updateSettings('streaming', v)} />

            <div className="pt-3 border-t border-gray-200">
                <h3 className="font-medium text-[#4267B2] mb-2">⚡ Reasoning Tokens</h3>

                <SettingSelect label="ระดับการคิด" tooltip="เลือกความลึก AI" options={['', 'low', 'medium', 'high']} value={settings.reasoning.effort ?? ''} onChange={(v) => updateReasoning('effort', v)} />
                <SettingInput label="จำกัด Reasoning Tokens" tooltip="จำกัด token reasoning" type="number" value={settings.reasoning.maxTokens ?? ''} onChange={(v) => updateReasoning('maxTokens', v)} />
                <ToggleSetting label="ซ่อน Reasoning" tooltip="ซ่อนขั้นตอนคิด" value={settings.reasoning.exclude} onChange={(v) => updateReasoning('exclude', v)} />
            </div>

            <div className="flex justify-between pt-3">
                <button
                    onClick={resetSettings}
                    className="px-4 py-2 rounded-lg bg-white/70 border border-[#e3e8f7] text-gray-700 
      hover:bg-white hover:shadow-[0_0_6px_rgba(139,92,246,0.2)] transition-all text-sm"
                >
                    ล้างค่า
                </button>

                <button
                    onClick={() => console.log('save', settings)}
                    className="px-4 py-2 rounded-lg text-white font-medium bg-gradient-to-r 
      from-[#3B82F6] via-[#8B5CF6] to-[#E91E63] hover:shadow-[0_0_15px_rgba(139,92,246,0.4)] 
      active:scale-95 transition-all text-sm"
                >
                    บันทึก
                </button>
            </div>
        </div>
    );
}